// This file is autogenerated from /frontend/sail-next/packages/docs/src/markdoc/demo/Button.js with go/sail-next-tailor-docs-publisher 

import React from 'react';
import { Button } from '@sail/ui';
/* eslint-disable no-alert */

const basic = {
  rendered: <>
      <Button type="primary">Primary</Button>
      <Button>Secondary</Button>
      <Button type="destructive">Destructive</Button>
    </>,
  source: `<Button type="primary">Hello!</Button>
<Button>Secondary</Button>
<Button type="destructive">Destructive</Button>`
};
const primary = {
  rendered: <Button type="primary" onPress={() => alert('Button was pressed')}>
      Primary button
    </Button>,
  source: `<Button type="primary" onPress={() => alert('Button was pressed')}>
  Primary button
</Button>`
};
const secondary = {
  rendered: <Button onPress={() => alert('Button was pressed')}>
      Secondary button
    </Button>,
  source: `<Button onPress={() => alert('Button was pressed')}>
  Secondary button
</Button>`
};
const destructive = {
  rendered: <Button type="destructive" onPress={() => alert('Button was pressed')}>
      Destructive button
    </Button>,
  source: `<Button type="destructive" onPress={() => alert('Button was pressed')}>
  Destructive button
</Button>`
};
const sizes = {
  rendered: <>
      <Button size="small">Small button</Button>
      <Button>Medium button</Button>
      <Button size="large">Large button</Button>
    </>,
  source: `<Button size="small">Small button</Button>
<Button>Medium button</Button>
<Button size="large">Large button</Button>`
};
const disabled = {
  rendered: <>
      <Button type="primary" disabled>
        Primary
      </Button>
      <Button disabled>Secondary</Button>
      <Button type="destructive" disabled>
        Destructive
      </Button>
    </>,
  source: `<Button type="primary" disabled>Hello!</Button>
<Button disabled>Secondary</Button>
<Button type="destructive" disabled>Destructive</Button>`
};
export const ButtonExamples = {
  basic,
  primary,
  secondary,
  destructive,
  sizes,
  disabled
};